import { render, staticRenderFns } from "./CourseGroupCard.vue?vue&type=template&id=6321ace1&scoped=true&"
import script from "./CourseGroupCard.vue?vue&type=script&lang=js&"
export * from "./CourseGroupCard.vue?vue&type=script&lang=js&"
import style0 from "./CourseGroupCard.vue?vue&type=style&index=0&id=6321ace1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6321ace1",
  null
  
)

export default component.exports